import { Card, SxProps, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { sxs } from '@utils/mui/sx';

interface SideContentCardProps {
    children: ReactNode;
    dataTestId?: string;
    onClick?: () => void;
    sx?: SxProps;
    title?: string;
}

const SideContentCard: FC<SideContentCardProps> = ({
    children,
    dataTestId,
    onClick,
    sx = {},
    title,
}) => (
    <Card
        data-test-id={dataTestId}
        elevation={0}
        onClick={onClick}
        sx={sxs([
            {
                backgroundColor: 'grey.700',
                border: 'none',
                borderRadius: 1,
                p: 2,
            },
            sx,
        ])}
    >
        {title && (
            <Typography sx={{ fontWeight: 'medium', mb: 1 }} variant="h5">
                {title}
            </Typography>
        )}
        {children}
    </Card>
);

export default SideContentCard;
